import { cellConfig } from "@topi/cell-config";

export const cellTranslationVariables = {
  supportEmailAddress: cellConfig.emails.support,
  salesEmailAddress: cellConfig.emails.sales,
  emergencyContactEmail: cellConfig.emails.emergencyContact,
};
